import { useState, useEffect, useRef } from 'react';
import { useSalesAssistStore } from 'features/chatAssist/ChatAssist.store';
import { msgInfo, errorResponse } from '../../constants';
import { askQuestionListenStreamEvents } from 'features/chatAssist/newServices/SSE/askQuestionStreamEvent';
const ChatAssistV3Logic = () => {
  const client_id = useSalesAssistStore((state) => state?.client_id);
  const conversation_id = useSalesAssistStore((state) => state?.conversation_id);
  const conversation = useSalesAssistStore((state) => state.conversation);
  const setConversationID = useSalesAssistStore((state) => state?.setConversationID);
  const addNewUserMessage = useSalesAssistStore((state) => state?.addNewUserMessage);
  const addAIResponseChunk = useSalesAssistStore((state) => state?.addAIResponseChunk);

  const messagesContainerRef = useRef(null);
  const firstQuestionRef = useRef(null);
  const firstResponseRef = useRef(null);

  const [value, setValue] = useState(''); //input value
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false); //to handle the loading status of the request

  const isJustSpaces = (m) => m.trim() === '';

  const onChange = (e) => {
    e.preventDefault();
    setValue(e.target.value);
  };

  const handleScroll = () => {
    const container = messagesContainerRef.current;
    if (container) {
      const { scrollTop } = container;

      if (scrollTop < 0) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    }
  };

  const scrollToBottom = () => {
    const container = messagesContainerRef.current;
    if (container) {
      container.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  const handleNewMessages = async (text) => {
    if (isJustSpaces(text)) return;

    addNewUserMessage(text);
    setValue('');
    setIsWaiting(true);

    const isFirstMessage = conversation.length < 2;

    await askQuestionListenStreamEvents({
      isFirstMessage,
      client_id,
      prompt: text,
      onMessage: (chunk) => {
        addAIResponseChunk(chunk);
      },
      onError: (err) => {
        console.error('Stream error:', err);
        addAIResponseChunk(errorResponse?.text);
      },
      onLoading: () => {
        setIsWaiting(false);
      },
      onSaveConversationID: (data) => {
        setConversationID(data);
      },
      conversation_id,
    });
  };

  const handleSendMessage = () => handleNewMessages(value, msgInfo?.sender);

  useEffect(() => {
    const container = messagesContainerRef.current;
    const scrollHandler = () => handleScroll();
    if (container) {
      container.addEventListener('scroll', scrollHandler);
      handleScroll();
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', scrollHandler);
      }
    };
  }, []);

  useEffect(() => {
    if (conversation.length === 0) return;

    const lastMessage = conversation[0];

    if (lastMessage.type === msgInfo.sender && firstQuestionRef.current) {
      firstQuestionRef.current.scrollIntoView({ block: 'start' });
    } else if (lastMessage.type === msgInfo.recipient && firstResponseRef.current) {
      firstResponseRef.current.scrollIntoView({ block: 'start' });
    }
  }, [conversation]);

  return {
    conversation,
    messagesContainerRef,
    firstQuestionRef,
    firstResponseRef,
    value,
    showScrollButton,
    isWaiting,
    isJustSpaces,
    onChange,
    scrollToBottom,
    handleSendMessage,
  };
};

export default ChatAssistV3Logic;
